<script>
	import { onDestroy, getContext } from 'svelte'
	import { modalLogin, modalCreateTextfile } from '../library/scripts/Store.svelte'
	import Shader from '../library/ShadersAndSpinners/Shader.svelte'
	import Modal from './Modal.svelte'
	import Login from './Login.svelte'

	import CreateTextfile from './CreateTextfile.svelte'

	const globals = getContext('globals')
	const modalWidth = globals.modalWidth
	const modalSmallWidth = globals.modalSmallWidth

	let showLogin = false

	let showCreateTexfile = false

	const mdlLogin = modalLogin.subscribe((cont) => {
		showLogin = cont
	})

	const mdlCreateTextfile = modalCreateTextfile.subscribe((cont) => {
		showCreateTexfile = cont
	})

	const modal_window = (w) => {
		if (w === 'login') modalLogin.set(false)
		if (w === 'createtextfile') modalCreateTextfile.set(false)
	}

	onDestroy(() => {
		mdlLogin
		mdlCreateTextfile
	})
</script>

{#if showLogin}
	<Shader>
		<div slot="content">
			<Modal on:closemodal={() => modal_window('login')} title="Login" modalWidth={modalSmallWidth}>
				<div slot="content"><Login /></div>
			</Modal>
		</div>
	</Shader>
{/if}

{#if showCreateTexfile}
	<Shader>
		<div slot="content">
			<Modal on:closemodal={() => modal_window('createtextfile')} title="Create Text-File" {modalWidth}>
				<div slot="content"><CreateTextfile /></div>
			</Modal>
		</div>
	</Shader>
{/if}
